/*
 * Coast at night hero: a town light shows its town in the card.
 * Hover, keyboard focus, click or Enter/Space on a light. No library. Without this file the card
 * shows the default town (rendered by Liquid) and the list of towns is in the page for screen readers.
 * Justified in docs/decisions-log.md (2026-09-22).
 */
(function () {
  function init(section) {
    var data = section.querySelector('[data-coast-towns]');
    var pins = section.querySelector('[data-coast-pins]');
    var card = section.querySelector('[data-coast-card]');
    if (!data || !pins || !card || section.dataset.coastReady) return;
    section.dataset.coastReady = '1';
    var towns;
    try {
      towns = JSON.parse(data.textContent);
    } catch (e) {
      return;
    }
    var t = card.querySelector('[data-t]');
    var c = card.querySelector('[data-c]');
    var k = card.querySelector('[data-k]');
    var link = card.querySelector('[data-map-link]');
    var current = null;

    function show(g) {
      var d = towns[g.getAttribute('data-i')];
      if (!d || g === current) return;
      current = g;
      t.textContent = d.n;
      c.textContent = d.c;
      k.textContent = '';
      d.k.forEach(function (name) {
        var li = document.createElement('li');
        li.textContent = name;
        k.appendChild(li);
      });
      if (link) link.href = link.getAttribute('data-map-url') + '#town-' + d.h;
      Array.prototype.forEach.call(pins.children, function (p) {
        p.classList.toggle('is-on', p === g);
      });
    }

    function pinFrom(e) {
      return e.target.closest ? e.target.closest('.dte-light') : null;
    }

    ['mouseover', 'focusin', 'click'].forEach(function (type) {
      pins.addEventListener(type, function (e) {
        var g = pinFrom(e);
        if (g) show(g);
      });
    });
    pins.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var g = pinFrom(e);
      if (!g) return;
      e.preventDefault();
      current = null;
      show(g);
    });
  }

  function run() {
    document.querySelectorAll('.dte-night').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
